export default "__VITE_ASSET__DyJTFXSw__"